import { BrowserRouter as Router } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import Routes from './router/components/Routes/Routes';
import routes from './router/routes';
import AuthProvider from './providers/Auth/Auth.provider';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes routes={routes} />
        <ToastContainer
          position="top-right"
          autoClose={5000}
          closeOnClick
          pauseOnFocusLoss
          pauseOnHover
        />
      </AuthProvider>
    </Router>
  );
}

export default App;
